import React from "react"

const Image = ({
  dataSizesPreset, // The preset for the image sizes ex: 'hero, gd, S, article'
  className, // Add additional classes to the image
  imgSrc, // The image source
  imgAlt, // The image alt text
  imgWidth, // The image width
  imgHeight, // The image height
  imgSrcSet, // The image srcset ex: 'image-1x.jpg 1x, image-2x.jpg 2x'
  imgSizes, // The image sizes ex: '(min-width: 768px) 768px, 100vw'
  loading = "auto", // The loading attribute for the image ex: 'lazy, eager, auto, unset, inherit, initial, none',
  preload = "auto", // The preload attribute for the image ex: 'auto, metadata, none',
  formats = [], // The image formats
  ...otherProps // Any other props ex: id, style, etc.
}) => {
  const getSizesPreset = (dataSizesPreset, src) => {
    const lastSlashIndex = src.lastIndexOf("/")
    const baseUrl = src.substring(0, lastSlashIndex + 1)
    const filename = src.substring(lastSlashIndex + 1)
    const lastDotIndex = filename.lastIndexOf(".")
    let f = filename
    if (lastDotIndex === -1) {
      f += ".webp" //no extension
    } else {
      f = filename.substring(0, lastDotIndex) + ".webp"
    }
    switch (dataSizesPreset) {
      case "hero":
        return {
          srcset: `${baseUrl}XXL_${f} 1920w,
              ${baseUrl}XL_${f} 1440w,
              ${baseUrl}L_${f} 770w,
              ${baseUrl}M_${f} 590w,
              ${baseUrl}S_${f} 390w`,
          sizes: `(max-width: 390px) 390px,
              (max-width: 590px) 590px,
              (max-width: 770px) 770px,
              (max-width: 1440px) 1440px,
              1920px
          `,
          media: `(
            (max-width: 390px) 100vw,
            (max-width: 590px) 100vw,
            (max-width: 770px) 100vw,
            (max-width: 1440px) 100vw,
            100vw
          )`,
          loading: "eager",
          fetchpriority: "high",
        }
      case "gd":
        return {
          srcset: `${baseUrl}M_${f} 590w,
              ${baseUrl}S_${f} 390w`,
          sizes: `(max-width: 390px) 390px,
              590px
          `,
          media: `(max-width: 590px) 100vw, 590px`,
        }
      case "S":
        return {
          srcset: `${baseUrl}S_${f} 390w`,
          sizes: `390px`,
          media: `390px`,
        }

      case "article":
        return {
          srcset: `${baseUrl}XL_${f} 1440w,
              ${baseUrl}L_${f} 770w,
              ${baseUrl}M_${f} 590w,
              ${baseUrl}S_${f} 390w`,
          sizes: `(max-width: 390px) 390px,
              (max-width: 590px) 590px,
              770px
          `,
          media: `(max-width: 590px) 100vw, 590px, 770px`,
        }
      default:
        return (
          <img
            src={imgSrc}
            alt={imgAlt}
            width={imgWidth}
            height={imgHeight}
            className={className}
            loading={loading}
            preload={preload}
            {...otherProps}
          />
        )
    }
  }
  if (!formats || formats.length === 0) {
    return (
      <img
        src={imgSrc}
        alt={imgAlt}
        width={imgWidth}
        height={imgHeight}
        className={className}
        loading={loading}
        preload={preload}
        {...otherProps}
      />
    )
  } else {
    const sizesPreset = getSizesPreset(dataSizesPreset, imgSrc)
    return (
      <img
        src={imgSrc}
        alt={imgAlt}
        className={className}
        srcSet={sizesPreset.srcset}
        width={imgWidth}
        height={imgHeight}
        sizes={sizesPreset.sizes}
        media={sizesPreset.media}
        loading={sizesPreset.loading || loading}
        fetchpriority={sizesPreset.fetchpriority}
        preload={preload}
        {...otherProps}
      />
    )
  }
}

export default Image
